<template>
  <b-container fluid>
    <b-row align-h="center">
      <b-col cols="10">
        <b-row class="mb-5 top-container align-items-center" align-h="center">
          <b-col sm="8" align-self="center">
            <h1 id="host" class="pt-3 d-flex justify-content-center">
              <span
                id="siteurl"
                class="text-truncate"
                @mouseover="onMouseHover($event)"
              >
                {{ $route.params.hostname }}
              </span>
              <b-tooltip v-if="tooltip" target="siteurl" placement="top">
                {{ $route.params.hostname }}
              </b-tooltip>
              <a
                class="d-flex align-items-center"
                :href="`http://` + $route.params.hostname"
                target="_blank"
              >
                <b-img class="mt-2 pl-2" src="~/static/images/goto.svg" />
              </a>
            </h1>
            <b-img
              v-if="siteScore >= 80"
              class="vector1"
              src="~/static/images/VECTOR01.svg"
            />
            <b-img
              v-else-if="siteScore <= 50"
              class="vector2"
              src="~/static/images/VECTOR03.svg"
            />
            <b-img
              v-else-if="siteScore > 50 < 80"
              class="vector3"
              src="~/static/images/VECTOR02.svg"
            />
          </b-col>
          <b-col id="scoreRing" sm="4">
            <Scorecard id="sitescore" :progress="siteScore" />
          </b-col>
        </b-row>
        <!-- <b-row class="mt-3 mb-3">
          <b-col sm="8">
            <h1 id="host">
              {{ $route.params.hostname
              }}<a :href="`http://` + $route.params.hostname" target="_blank">
                <b-img class="pl-2" src="~/static/images/goto.svg" alt="true" />
              </a>
            </h1>
          </b-col>
        </b-row> -->
        <div v-for="(error, index) in siteErrors" :key="index">
          <Rule
            :status="error.rule_status"
            :code="error.code"
            :title="error.title"
          />
        </div>
        <h2 id="pagesrule">
          Score of your pages
        </h2>
        <div
          v-if="
            siteStatus === 'Partial' &&
              (typeof pageList === 'undefined' ? true : pageList.length === 0)
          "
          class="w-100 d-flex justify-content-center"
        >
          <b-spinner style="width: 3rem; height: 3rem;" label="Loading..." />
        </div>
        <div v-for="page in pageList" :key="page.page_id">
          <b-alert class="page-alert" show>
            <b-row
              class="page-box d-flex justify-content-between align-items-center px-3"
            >
              <b-col class="alert-link">
                <div class="align-items-center d-flex flex-row flex-nowrap">
                  <div
                    :id="page.url"
                    class="align-middle text-truncate"
                    @mouseover="onMouseHover($event)"
                  >
                    {{ page.url }}
                  </div>
                  <b-tooltip v-if="tooltip" :target="page.url" placement="top">
                    {{ page.url }}
                  </b-tooltip>
                  <div v-if="page.status === 'Done'">
                    <b-button
                      class="svgButton"
                      target="_blank"
                      :to="$route.params.hostname + '/' + page.page_id"
                    />
                  </div>
                </div>
              </b-col>
              <div id="svgNext" class="d-flex align-items-center">
                <div
                  v-if="
                    page.status === 'pending' ||
                      (page.status === 'Done' &&
                        typeof page.score === 'undefined')
                  "
                  class="px-1 pt-1"
                >
                  <b-spinner label="Loading..." />
                </div>
                <div
                  v-else-if="page.status === 'Done'"
                  class="score align-items-center"
                >
                  {{ page.score }}
                </div>
                <div v-else class="score align-items-center pb-1">
                  <a v-b-tooltip.hover.topleft :title="page.error_msg">
                    <b-icon icon="exclamation-triangle" />
                  </a>
                </div>
              </div>
            </b-row>
          </b-alert>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import '@/static/css/app.css'
import Rule from '@/components/Rule.vue'
import Scorecard from '@/components/Scorecard'
export default {
  layout: 'seo',
  components: {
    Rule,
    Scorecard
  },
  async asyncData({ store, params, redirect }) {
    await store.dispatch('getSiteDetails', { params, redirect })
  },
  data() {
    return {
      tooltip: null
    }
  },
  computed: {
    siteErrors() {
      return this.$store.getters.getSiteErrors
    },
    siteScore() {
      return this.$store.getters.getSiteScore
    },
    pageList() {
      return this.$store.getters.getPageList
    },
    siteStatus() {
      return this.$store.getters.getSiteStatus
    }
  },
  async mounted() {
    await this.$store.dispatch('refreshSiteDetails', this.$route.params)
  },
  methods: {
    onMouseHover(e) {
      if (e.toElement.offsetWidth < e.toElement.scrollWidth) {
        this.tooltip = true
      } else {
        this.tooltip = false
      }
    }
  },
  head() {
    return {
      title: 'WebAuditor'
    }
  }
}
</script>
<style>
body {
  background-color: white;
}

#svgNext {
  min-height: 58px;
}
.alert-link {
  padding-left: 25px;
}
.alert {
  padding: 0px;
}
.page-alert .row {
  margin: 0;
  padding: 0;
}
.page-alert .alert-link {
  max-width: calc(100% - 60px);
  padding: 0;
}
.svgButton {
  height: 24px;
  width: auto;
  background: url(../../static/images/right-circle-arrow.svg) center no-repeat;
  background-color: transparent !important;
  border-style: none !important;
  cursor: pointer;
}
.score {
  font-size: 39px;
}
.btn:focus,
.btn:active {
  outline: none !important;
  box-shadow: none !important;
}
#sitescore {
  height: 160px;
  width: 160px;
  position: relative;
  float: right;
  margin: auto;
}
h1 {
  color: #484748;
}
#pagesrule {
  margin-top: 45px;
  margin-bottom: 21px;
}
@media only screen and (min-width: 150px) and (max-width: 780px) {
  #sitescore {
    float: none;
  }
  #host {
    font-size: 2rem;
    white-space: nowrap;
  }
  .page-box {
    flex-wrap: nowrap;
  }
  .page-link {
    display: flex;
  }
  .col-10 {
    max-width: 95%;
  }
  .top-container {
    flex-direction: column-reverse;
  }
}
</style>
